export default class WordData {
  /** @type {number} */
  stickPosX
  /** @type {number} */
  stickPosY
  /** @type {string} */
  word
  /** @type {boolean} */
  isLocked
  /** @type {number} */
  angle
  /** @type {string} */
  stickSrc
  /** @type {string} */
  blendType 
  /** @type {any} */ 
  raw
  /**
   * @param {{
   *  stickPosX: number,
   *  stickPosY: number,
   *  word: string,
   *  isLocked: boolean,
   *  lockedSrc: string,  
   *  stickSrc: string
   * }} data
   */
  constructor(data) {
    this.stickPosX = data.stickPosX
    this.stickPosY = data.stickPosY
    this.word = data.word
    this.isLocked = data.isLocked
    this.angle = data.angle;
    this.stickSrc = data.stickSrc
    this.blendType = data.blendType;
    this.raw=data;
  }
}
